<div *ngIf="activeIcon" style="padding-right: 16px; padding-left: 16px;" nz-button nz-popover [(nzPopoverVisible)]="detailVisible"
  (nzPopoverVisibleChange)="deviceChange($event)" nzPopoverTrigger="click" [nzPopoverTitle]="titleDevice"
  [nzPopoverContent]="deviceDetail" nzPopoverPlacement="bottom">
  <nz-badge [nzCount]="iconTemplate">
    <nz-avatar nzSize="small" nzSrc="/assets/default/images/icons/pos.png" [nzShape]="'square'"></nz-avatar>
  </nz-badge>
</div>

<ng-template #iconTemplate>
  <i nz-icon [nzType]="terminalFound ? 'check' : 'warning'" class="ant-scroll-number-custom-component"></i>
</ng-template>

<ng-template #titleDevice>
  <div>
    <div nz-row>
      <div nz-col [nzSpan]="12" (click)="closeDetail()">
        <span>Dispositivo</span>
      </div>
      <div nz-col [nzSpan]="12">
        <a *ngIf="!serviceEnabled || terminalErrMessage"><i style="float: right" nz-icon nzType="reload"
            (click)="reloadData()"></i></a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deviceDetail>
  <div *ngIf="terminalErrMessage">
    <p>{{terminalErrMessage}}</p>
  </div>
  <div>
    <div *ngIf="terminalType">Tipo: {{terminalType}}</div>
    <div *ngIf="terminalBrand">Marca: {{terminalBrand}}</div>
    <div *ngIf="terminalModel">Modelo: {{terminalModel}}</div>
    <div *ngIf="terminalSerial">Serial: {{terminalSerial}}</div>
    <div *ngIf="terminalPosSerial">Serial POS: {{terminalPosSerial}}</div>
  </div>
  <div *ngIf="serviceEnabled">
    Puerto:
    <nz-input-number [disabled]="terminalSerial || terminalPosSerial" [(ngModel)]="portNumber" [nzMin]="1" [nzMax]="10"
      [nzStep]="1"></nz-input-number>
  </div>
  <div class="mt-2">
    <button *ngIf="serviceEnabled && !terminalSerial && !terminalPosSerial" class="m-2" nz-button nzType="primary"
      (click)="changeDevicePort()">Modificar puerto</button>
    <button clarr="m-2" nz-button nzType="default" (click)="closeDetail()">Cerrar</button>
  </div>
</ng-template>